// Curated word bank for the word search game
// Words are 4-8 letters, common English words that are fun to find

export const WORD_BANK: string[] = [
  // 4-letter words
  'BALL', 'BIRD', 'BOOK', 'CAKE', 'CAMP', 'CARD', 'CHEF', 'CITY', 'CLAP',
  'CLUB', 'COAT', 'COIN', 'COOK', 'CORN', 'CRAB', 'DARK', 'DAWN', 'DEER',
  'DESK', 'DISH', 'DOCK', 'DOOR', 'DOVE', 'DOWN', 'DRUM', 'DUCK', 'DUST',
  'EAST', 'ECHO', 'EDGE', 'FACE', 'FAIR', 'FALL', 'FARM', 'FAST', 'FERN',
  'FIRE', 'FISH', 'FLAG', 'FLIP', 'FOAM', 'FOLD', 'FOOD', 'FOOT', 'FORK',
  'FORT', 'FROG', 'GAME', 'GATE', 'GIFT', 'GIRL', 'GLOW', 'GOAT', 'GOLD',
  'GOLF', 'GOOD', 'GRAY', 'GRIP', 'GUST', 'HAIR', 'HALL', 'HAND', 'HARP',
  'HAWK', 'HEAT', 'HELP', 'HERO', 'HIGH', 'HILL', 'HOME', 'HOOD', 'HOOK',
  'HOPE', 'HORN', 'HOSE', 'HOUR', 'HUNT', 'IDEA', 'IRON', 'ISLE', 'ITEM',
  'JADE', 'JAZZ', 'JEEP', 'JOKE', 'JUMP', 'JUNE', 'JURY', 'JUST', 'KALE',
  'KEEN', 'KEEP', 'KELP', 'KICK', 'KIND', 'KING', 'KITE', 'KNEE', 'KNOB',
  'KNOT', 'LACE', 'LADY', 'LAKE', 'LAMB', 'LAMP', 'LAND', 'LANE', 'LAST',
  'LAWN', 'LEAF', 'LEFT', 'LEMON', 'LENS', 'LIFE', 'LIFT', 'LIME', 'LINE',
  'LINK', 'LION', 'LIST', 'LOAD', 'LOCK', 'LOGO', 'LOOK', 'LOOP', 'LORD',
  'LOVE', 'LUCK', 'LUMP', 'LYNX', 'MAID', 'MAIL', 'MAIN', 'MAKE', 'MALL',
  'MANGO', 'MANY', 'MAPLE', 'MARK', 'MASK', 'MATH', 'MAZE', 'MEAL', 'MEAT',
  'MELON', 'MENU', 'MICE', 'MILK', 'MILL', 'MIND', 'MINT', 'MISS', 'MIST',
  'MODE', 'MOON', 'MOSS', 'MOST', 'MOTH', 'MOVE', 'MUCH', 'NAIL', 'NAME',
  'NAVY', 'NEAR', 'NEAT', 'NECK', 'NEED', 'NEST', 'NEWS', 'NEXT', 'NICE',
  'NOON', 'NOSE', 'NOTE', 'OAKS', 'OARS', 'OATH', 'OBOE', 'OCEAN', 'OKRA',
  'ONLY', 'OPEN', 'OVAL', 'OVEN', 'OVER', 'PACE', 'PACK', 'PAGE', 'PAIL',
  'PAIN', 'PAIR', 'PALM', 'PANDA', 'PARK', 'PART', 'PASS', 'PAST', 'PATH',
  'PEAK', 'PEAR', 'PEAS', 'PEEL', 'PENCIL', 'PENNY', 'PIANO', 'PICK', 'PIER',
  'PIKE', 'PINE', 'PINK', 'PIPE', 'PITA', 'PLAN', 'PLUM', 'POND', 'PONY',
  'POOL', 'PORT', 'POST', 'PUMP', 'PURE', 'PUSH', 'QUIZ', 'RACE', 'RACK',
  'RAIN', 'RAKE', 'RAMP', 'RANG', 'RANK', 'RARE', 'RAVEN', 'READ', 'REAL',
  'REEF', 'REST', 'RICE', 'RICH', 'RIDE', 'RING', 'RISE', 'RISK', 'ROAD',
  'ROAM', 'ROBE', 'ROCK', 'ROLL', 'ROOF', 'ROOM', 'ROOT', 'ROPE', 'ROSE',
  'RUBY', 'RUDE', 'RULE', 'RUSH', 'RUST', 'SAFE', 'SAGE', 'SAIL', 'SALT',
  'SAND', 'SAVE', 'SEAL', 'SEAT', 'SEED', 'SELF', 'SHIP', 'SHOP', 'SHOW',
  'SIDE', 'SIGN', 'SILK', 'SINK', 'SIZE', 'SKIN', 'SLED', 'SLIP', 'SLOW',
  'SNAP', 'SNOW', 'SOAP', 'SOCK', 'SOFA', 'SOFT', 'SOIL', 'SOME', 'SONG',
  'SOON', 'SORT', 'SOUL', 'SOUP', 'SPOT', 'STAR', 'STAY', 'STEM', 'STEP',
  'STOP', 'SUIT', 'SURF', 'SWAN', 'SWIM', 'TAIL', 'TAKE', 'TALK', 'TALL',
  'TANK', 'TAPE', 'TASK', 'TAXI', 'TEAM', 'TEAR', 'TELL', 'TENT', 'TERM',
  'TEST', 'THAN', 'THAT', 'THEM', 'THEN', 'THEY', 'THIS', 'THORN', 'TIDE',
  'TIDY', 'TILE', 'TIME', 'TINY', 'TOAD', 'TOLL', 'TONE', 'TOOL', 'TOSS',
  'TOUR', 'TOWN', 'TOYS', 'TRAP', 'TRAY', 'TREE', 'TRIM', 'TRIP', 'TRUE',
  'TUBE', 'TUNA', 'TUNE', 'TURN', 'TYPE', 'UNIT', 'UPON', 'USED', 'USER',
  'VASE', 'VAST', 'VEIL', 'VENT', 'VERB', 'VERY', 'VEST', 'VIEW', 'VINE',
  'VOTE', 'WADE', 'WAGE', 'WAIT', 'WAKE', 'WALK', 'WALL', 'WAND', 'WANT',
  'WARM', 'WARN', 'WASH', 'WASP', 'WAVE', 'WAX', 'WEAK', 'WEAR', 'WEEK',
  'WELL', 'WEST', 'WHALE', 'WHAT', 'WHEAT', 'WHEEL', 'WHEN', 'WHIP', 'WIDE',
  'WIFE', 'WILD', 'WILL', 'WIND', 'WINE', 'WING', 'WIRE', 'WISE', 'WISH',
  'WITH', 'WOLF', 'WOOD', 'WOOL', 'WORD', 'WORK', 'WORM', 'WRAP', 'YARD',
  'YARN', 'YEAR', 'YELL', 'YOGA', 'YOLK', 'YOUR', 'ZEAL', 'ZERO', 'ZONE',
  'ZOOM',
  
  // 5-letter words
  'APPLE', 'ARROW', 'BACON', 'BADGE', 'BAKER', 'BEACH', 'BEARD', 'BEAST',
  'BENCH', 'BERRY', 'BLADE', 'BLANK', 'BLAZE', 'BLEND', 'BLESS', 'BLIND',
  'BLOCK', 'BLOOM', 'BOARD', 'BOOTS', 'BRAID', 'BRAIN', 'BRAKE', 'BRAND',
  'BRAVE', 'BREAD', 'BREAK', 'BRICK', 'BRIDE', 'BRIEF', 'BRING', 'BRISK',
  'BROAD', 'BROOK', 'BROOM', 'BRUSH', 'BUILD', 'BURST', 'CABIN', 'CAMEL',
  'CANDY', 'CARGO', 'CARRY', 'CATCH', 'CHAIN', 'CHAIR', 'CHALK', 'CHARM',
  'CHART', 'CHASE', 'CHEAP', 'CHEER', 'CHESS', 'CHEST', 'CHICK', 'CHILD',
  'CHILL', 'CHINA', 'CHIRP', 'CHORD', 'CHOSE', 'CHUNK', 'CHURN', 'CIDER',
  'CIGAR', 'CINCH', 'CIRCA', 'CIVIC', 'CIVIL', 'CLAIM', 'CLAMP', 'CLANG',
  'CLANK', 'CLASH', 'CLASP', 'CLASS', 'CLEAN', 'CLEAR', 'CLERK', 'CLICK',
  'CLIFF', 'CLIMB', 'CLING', 'CLOAK', 'CLOCK', 'CLONE', 'CLOSE', 'CLOTH',
  'CLOUD', 'CLOWN', 'COACH', 'COAST', 'COMET', 'CORAL', 'COUCH', 'COUNT',
  'COURT', 'COVER', 'CRAFT', 'CRANE', 'CRASH', 'CRAWL', 'CRAZY', 'CREAM',
  'CREEK', 'CREEP', 'CREST', 'CRISP', 'CROSS', 'CROWD', 'CROWN', 'CRUSH',
  'CRUST', 'CYCLE', 'DAILY', 'DAIRY', 'DANCE', 'DEPTH', 'DIGIT', 'DINER',
  'DIZZY', 'DOUBT', 'DOUGH', 'DRAFT', 'DRAIN', 'DRAPE', 'DRAWL', 'DRAWN',
  'DREAD', 'DREAM', 'DRESS', 'DRIED', 'DRIFT', 'DRILL', 'DRINK', 'DRIVE',
  'DROWN', 'DWARF', 'DWELL', 'EAGLE', 'EARLY', 'EARTH', 'EATEN', 'EATER',
  'EAVES', 'ELDER', 'ELITE', 'EMBER', 'EMPTY', 'ENEMY', 'ENJOY', 'ENTER',
  'ENTRY', 'EQUAL', 'EQUIP', 'ERASE', 'ERROR', 'ERUPT', 'ESSAY', 'EVENT',
  'EVERY', 'EXACT', 'EXALT', 'EXCEL', 'EXIST', 'EXPEL', 'EXTRA', 'FAINT',
  'FAIRY', 'FAITH', 'FALSE', 'FANCY', 'FAVOR', 'FEAST', 'FENCE', 'FERRY',
  'FETCH', 'FEVER', 'FIBER', 'FIELD', 'FIFTH', 'FIFTY', 'FIGHT', 'FINAL',
  'FIRST', 'FIXED', 'FLAIR', 'FLAKE', 'FLAME', 'FLANK', 'FLARE', 'FLASH',
  'FLASK', 'FLEET', 'FLESH', 'FLICK', 'FLING', 'FLINT', 'FLOAT', 'FLOCK',
  'FLOOD', 'FLOOR', 'FLORA', 'FLOUR', 'FLUID', 'FLUNK', 'FLUSH', 'FLUTE',
  'FOCAL', 'FOCUS', 'FOGGY', 'FORGE', 'FORTH', 'FORTY', 'FORUM', 'FOSSIL',
  'FOUND', 'FRAME', 'FRANK', 'FRAUD', 'FREAK', 'FRESH', 'FRIED', 'FRONT',
  'FROST', 'FRUIT', 'FUDGE', 'FULLY', 'FUNGI', 'FUNNY', 'FUZZY', 'GAUGE',
  'GIANT', 'GIVEN', 'GLADE', 'GLARE', 'GLASS', 'GLEAM', 'GLIDE', 'GLOBE',
  'GLOOM', 'GLORY', 'GLOSS', 'GLOVE', 'GNARL', 'GNASH', 'GOING', 'GOOSE',
  'GORGE', 'GOURD', 'GRACE', 'GRADE', 'GRAIN', 'GRAND', 'GRANT', 'GRAPE',
  'GRAPH', 'GRASP', 'GRASS', 'GRATE', 'GRAVE', 'GRAVY', 'GRAZE', 'GREAT',
  'GREED', 'GREEN', 'GREET', 'GRIEF', 'GRILL', 'GRIND', 'GRIPE', 'GROAN',
  'GROOM', 'GROPE', 'GROSS', 'GROUP', 'GROVE', 'GROWL', 'GROWN', 'GUARD',
  'GUESS', 'GUEST', 'GUIDE', 'GUILD', 'GUILT', 'GUISE', 'GULCH', 'GUMMY',
  'GUPPY', 'GUSTO', 'GUSTY', 'HABIT', 'HAIRY', 'HAPPY', 'HASTE', 'HATCH',
  'HAUNT', 'HAVEN', 'HEART', 'HEAVY', 'HEDGE', 'HEIST', 'HELLO', 'HENCE',
  'HERON', 'HIPPO', 'HITCH', 'HOBBY', 'HOIST', 'HOLLY', 'HOMER', 'HONEY',
  'HONOR', 'HORSE', 'HOTEL', 'HOUND', 'HOUSE', 'HOVER', 'HUMAN', 'HUMID',
  'HUMOR', 'HYENA', 'ICICLE', 'IDEAL', 'IMAGE', 'IMPLY', 'INDEX', 'INNER',
  'INPUT', 'ISSUE', 'IVORY', 'JELLY', 'JEWEL', 'JOINT', 'JOLLY', 'JUDGE',
  'JUICE', 'JUMBO', 'JUMPY', 'KARMA', 'KAYAK', 'KEBAB', 'KHAKI', 'KINKY',
  'KIOSK', 'KITTY', 'KNACK', 'KNEAD', 'KNEEL', 'KNIFE', 'KNOCK', 'KNOWN',
  'KOALA', 'LABEL', 'LABOR', 'LANCE', 'LARGE', 'LASER', 'LATCH', 'LATER',
  'LAUGH', 'LAYER', 'LEAKY', 'LEAPT', 'LEARN', 'LEASE', 'LEAST', 'LEAVE',
  'LEDGE', 'LEGAL', 'LEMON', 'LEVEL', 'LEVER', 'LIGHT', 'LILAC', 'LIMIT',
  'LINEN', 'LINER', 'LLAMA', 'LOBBY', 'LOCAL', 'LODGE', 'LOFTY', 'LOGIC',
  'LOOSE', 'LORRY', 'LOTUS', 'LOUSY', 'LOVER', 'LOWER', 'LOYAL', 'LUCKY',
  'LUNAR', 'LUNCH', 'LUNGE', 'LUSTY', 'LYING', 'LYRIC', 'MACHO', 'MACRO',
  'MADAM', 'MAGIC', 'MAJOR', 'MAKER', 'MAMBO', 'MANGO', 'MANOR', 'MAPLE',
  'MARCH', 'MARRY', 'MARSH', 'MATCH', 'MAYOR', 'MEDAL', 'MEDIA', 'MELON',
  'MERCY', 'MERGE', 'MERIT', 'MERRY', 'METAL', 'METER', 'MIGHT', 'MIMIC',
  'MINOR', 'MINUS', 'MIRTH', 'MISTY', 'MIXER', 'MODEL', 'MODEM', 'MOIST',
  'MOLAR', 'MONEY', 'MONTH', 'MOOSE', 'MORAL', 'MOTOR', 'MOTTO', 'MOULD',
  'MOUNT', 'MOURN', 'MOUSE', 'MOUTH', 'MOVIE', 'MUDDY', 'MULCH', 'MURAL',
  'MUSIC', 'MUSTY', 'NAIVE', 'NANNY', 'NASAL', 'NASTY', 'NAVAL', 'NAVEL',
  'NERVE', 'NEVER', 'NEWER', 'NEWLY', 'NICER', 'NICHE', 'NIGHT', 'NINJA',
  'NINTH', 'NOBLE', 'NOISE', 'NOMAD', 'NORTH', 'NOTCH', 'NOTED', 'NOVEL',
  'NUDGE', 'NURSE', 'NUTTY', 'NYLON', 'OCCUR', 'OCEAN', 'OCTET', 'OFFER',
  'OFTEN', 'OLIVE', 'ONION', 'ONSET', 'OPERA', 'OPTIC', 'ORBIT', 'ORDER',
  'ORGAN', 'OTHER', 'OTTER', 'OUGHT', 'OUNCE', 'OUTER', 'OUTGO', 'OVARY',
  'OWING', 'OXIDE', 'OZONE', 'PADDY', 'PAGAN', 'PAINT', 'PANEL', 'PANIC',
  'PANTS', 'PAPER', 'PARTY', 'PASTA', 'PASTE', 'PASTY', 'PATCH', 'PAUSE',
  'PEACE', 'PEACH', 'PEARL', 'PEDAL', 'PENNY', 'PERCH', 'PERIL', 'PERKY',
  'PETAL', 'PETTY', 'PHASE', 'PHONE', 'PHOTO', 'PIANO', 'PIECE', 'PILOT',
  'PINCH', 'PINEY', 'PIOUS', 'PITCH', 'PITHY', 'PIVOT', 'PIXEL', 'PIZZA',
  'PLACE', 'PLAID', 'PLAIN', 'PLANE', 'PLANK', 'PLANT', 'PLATE', 'PLAZA',
  'PLEAD', 'PLEAT', 'PLEDGE', 'PLIER', 'PLUCK', 'PLUMB', 'PLUME', 'PLUMP',
  'PLUNGE', 'PLUNK', 'PLUS', 'PLUSH', 'POACH', 'POINT', 'POISE', 'POKER',
  'POLAR', 'POLKA', 'POLYP', 'PORCH', 'POSER', 'POSIT', 'POSSE', 'POUCH',
  'POUND', 'POWER', 'PRANK', 'PRAWN', 'PRESS', 'PRICE', 'PRIDE', 'PRIME',
  'PRINT', 'PRIOR', 'PRISM', 'PRIVY', 'PRIZE', 'PROBE', 'PROMO', 'PRONE',
  'PRONG', 'PROOF', 'PROSE', 'PROUD', 'PROVE', 'PROWL', 'PROXY', 'PRUDE',
  'PRUNE', 'PSALM', 'PUBIC', 'PULSE', 'PUNCH', 'PUPIL', 'PUPPY', 'PURGE',
  'PURSE', 'PUSHY', 'PYGMY', 'QUACK', 'QUALM', 'QUART', 'QUEEN', 'QUERY',
  'QUEST', 'QUEUE', 'QUICK', 'QUIET', 'QUILL', 'QUILT', 'QUIRK', 'QUOTA',
  'QUOTE', 'RABBI', 'RACER', 'RADAR', 'RADIO', 'RAINY', 'RAISE', 'RALLY',
  'RANCH', 'RANGE', 'RAPID', 'RATIO', 'RAZOR', 'REACH', 'REACT', 'READY',
  'REALM', 'REAP', 'REBEL', 'RECAP', 'RECUR', 'REFER', 'REGAL', 'REIGN',
  'RELAX', 'RELAY', 'RELIC', 'REMIT', 'RENEW', 'REPAY', 'REPEL', 'REPLY',
  'RERUN', 'RESET', 'RESIN', 'RETRO', 'RETRY', 'REVEL', 'RHINO', 'RHYME',
  'RIDER', 'RIDGE', 'RIFLE', 'RIGHT', 'RIGID', 'RIGOR', 'RINSE', 'RIPEN',
  'RISEN', 'RISER', 'RISKY', 'RITZY', 'RIVAL', 'RIVER', 'RIVET', 'ROAST',
  'ROBIN', 'ROBOT', 'ROCKY', 'RODEO', 'ROGUE', 'ROOMY', 'ROOST', 'ROTOR',
  'ROUGE', 'ROUGH', 'ROUND', 'ROUSE', 'ROUTE', 'ROWDY', 'ROYAL', 'RUMBA',
  'RUMOR', 'RUPEE', 'RURAL', 'RUSTY', 'SADLY', 'SAINT', 'SALAD', 'SALLY',
  'SALON', 'SALSA', 'SALTY', 'SALVE', 'SANDY', 'SASSY', 'SATIN', 'SATIRE',
  'SAUCE', 'SAUNA', 'SAUTE', 'SAVOR', 'SAVVY', 'SCALD', 'SCALE', 'SCALP',
  'SCALY', 'SCAMP', 'SCANT', 'SCARE', 'SCARF', 'SCARY', 'SCENE', 'SCENT',
  'SCOLD', 'SCONE', 'SCOOP', 'SCOPE', 'SCORE', 'SCORN', 'SCOUT', 'SCOWL',
  'SCRAM', 'SCRAP', 'SCREE', 'SCREW', 'SCRUB', 'SEIZE', 'SENSE', 'SERVE',
  'SEVEN', 'SHADE', 'SHAKE', 'SHALL', 'SHAME', 'SHAPE', 'SHARD', 'SHARE',
  'SHARK', 'SHARP', 'SHAVE', 'SHAWL', 'SHEAR', 'SHEEN', 'SHEEP', 'SHEER',
  'SHEET', 'SHELF', 'SHELL', 'SHIFT', 'SHINY', 'SHIRE', 'SHIRT', 'SHOCK',
  'SHONE', 'SHOOK', 'SHOOT', 'SHORE', 'SHORT', 'SHOUT', 'SHOWN', 'SHOWY',
  'SHRUB', 'SHRUG', 'SIEGE', 'SIGHT', 'SIGMA', 'SILKY', 'SILLY', 'SINCE',
  'SIXTH', 'SIXTY', 'SIZED', 'SKATE', 'SKIER', 'SKILL', 'SKIMP', 'SKIRT',
  'SKULL', 'SKUNK', 'SLACK', 'SLAIN', 'SLANG', 'SLANT', 'SLASH', 'SLATE',
  'SLAVE', 'SLEEK', 'SLEEP', 'SLEET', 'SLICE', 'SLICK', 'SLIDE', 'SLIME',
  'SLIMY', 'SLING', 'SLINK', 'SLOPE', 'SLOSH', 'SLOTH', 'SLUMP', 'SLURP',
  'SLUSH', 'SMACK', 'SMALL', 'SMART', 'SMASH', 'SMEAR', 'SMELL', 'SMELT',
  'SMILE', 'SMIRK', 'SMITE', 'SMITH', 'SMOCK', 'SMOKE', 'SMOKY', 'SNACK',
  'SNAIL', 'SNAKE', 'SNARE', 'SNARL', 'SNEAK', 'SNEER', 'SNIDE', 'SNIFF',
  'SNORE', 'SNORT', 'SNOUT', 'SNOWY', 'SNUCK', 'SOBER', 'SOLAR', 'SOLID',
  'SOLVE', 'SONAR', 'SONIC', 'SORRY', 'SOUND', 'SOUTH', 'SPACE', 'SPADE',
  'SPARE', 'SPARK', 'SPASM', 'SPAWN', 'SPEAK', 'SPEAR', 'SPECK', 'SPEED',
  'SPELL', 'SPEND', 'SPENT', 'SPICE', 'SPICY', 'SPILL', 'SPINE', 'SPIRIT',
  'SPITE', 'SPLAT', 'SPLIT', 'SPOIL', 'SPOKE', 'SPOOF', 'SPOOK', 'SPOOL',
  'SPOON', 'SPORT', 'SPOUT', 'SPRAY', 'SPREE', 'SPRIG', 'SPUNK', 'SQUAD',
  'SQUAT', 'SQUIB', 'SQUID', 'STACK', 'STAFF', 'STAGE', 'STAIN', 'STAIR',
  'STAKE', 'STALE', 'STALK', 'STALL', 'STAMP', 'STAND', 'STANK', 'STARE',
  'STARK', 'START', 'STASH', 'STATE', 'STAVE', 'STEAK', 'STEAL', 'STEAM',
  'STEEL', 'STEEP', 'STEER', 'STERN', 'STICK', 'STIFF', 'STILL', 'STING',
  'STINK', 'STINT', 'STOCK', 'STOIC', 'STOMP', 'STONE', 'STONY', 'STOOD',
  'STOOL', 'STOOP', 'STORE', 'STORK', 'STORM', 'STORY', 'STOUT', 'STOVE',
  'STRAP', 'STRAW', 'STRAY', 'STRIP', 'STRUT', 'STUCK', 'STUDY', 'STUFF',
  'STUMP', 'STUNG', 'STUNK', 'STUNT', 'STYLE', 'SUAVE', 'SUGAR', 'SUITE',
  'SULKY', 'SUNNY', 'SUPER', 'SURGE', 'SUSHI', 'SWAMP', 'SWARM', 'SWEAR',
  'SWEAT', 'SWEEP', 'SWEET', 'SWELL', 'SWEPT', 'SWIFT', 'SWINE', 'SWING',
  'SWIPE', 'SWIRL', 'SWISS', 'SWORD', 'SWORE', 'SWORN', 'SWUNG', 'SYRUP',
  'TABBY', 'TABLE', 'TACIT', 'TACKY', 'TAFFY', 'TAINT', 'TAKEN', 'TAKER',
  'TALLY', 'TALON', 'TANGO', 'TANGY', 'TAPER', 'TAPIR', 'TARDY', 'TASTE',
  'TASTY', 'TATTY', 'TAUNT', 'TAWNY', 'TEACH', 'TEDDY', 'TEETH', 'TEMPO',
  'TENSE', 'TENTH', 'TEPEE', 'TEPID', 'TERRA', 'TERSE', 'THANK', 'THEFT',
  'THEIR', 'THEME', 'THERE', 'THESE', 'THICK', 'THIEF', 'THIGH', 'THING',
  'THINK', 'THIRD', 'THORN', 'THOSE', 'THREE', 'THREW', 'THROW', 'THUD',
  'THUG', 'THUMB', 'THUMP', 'TIARA', 'TIDAL', 'TIGER', 'TIGHT', 'TILDE',
  'TIMER', 'TIMID', 'TIPSY', 'TIRED', 'TITAN', 'TITLE', 'TOAST', 'TODAY',
  'TOKEN', 'TONAL', 'TONGS', 'TONIC', 'TOOTH', 'TOPAZ', 'TOPIC', 'TORCH',
  'TORSO', 'TOTAL', 'TOTEM', 'TOUCH', 'TOUGH', 'TOWEL', 'TOWER', 'TOXIC',
  'TRACE', 'TRACK', 'TRACT', 'TRADE', 'TRAIL', 'TRAIN', 'TRAIT', 'TRAMP',
  'TRASH', 'TRAWL', 'TREAD', 'TREAT', 'TREND', 'TRIAL', 'TRIBE', 'TRICK',
  'TRIED', 'TRILL', 'TRIMS', 'TRITE', 'TROLL', 'TROOP', 'TROUT', 'TRUCE',
  'TRUCK', 'TRULY', 'TRUMP', 'TRUNK', 'TRUST', 'TRUTH', 'TULIP', 'TUMOR',
  'TUNIC', 'TURBO', 'TUTOR', 'TWANG', 'TWEAK', 'TWEED', 'TWEET', 'TWICE',
  'TWIGS', 'TWINE', 'TWIRL', 'TWIST', 'TYING', 'UDDER', 'ULCER', 'ULTRA',
  'UMBRA', 'UNCLE', 'UNCUT', 'UNDER', 'UNDID', 'UNDUE', 'UNFED', 'UNFIT',
  'UNIFY', 'UNION', 'UNITE', 'UNITY', 'UNTIL', 'UPPER', 'UPSET', 'URBAN',
  'URGED', 'URINE', 'USAGE', 'USHER', 'USING', 'USUAL', 'UTTER', 'VAGUE',
  'VALID', 'VALOR', 'VALUE', 'VALVE', 'VAPID', 'VAPOR', 'VAULT', 'VAUNT',
  'VEGAN', 'VEINY', 'VENUE', 'VERGE', 'VERSE', 'VICAR', 'VIDEO', 'VIGOR',
  'VILLA', 'VINYL', 'VIOLA', 'VIPER', 'VIRAL', 'VIRUS', 'VISIT', 'VISOR',
  'VISTA', 'VITAL', 'VIVID', 'VIXEN', 'VOCAL', 'VODKA', 'VOGUE', 'VOICE',
  'VOILA', 'VOMIT', 'VOTER', 'VOUCH', 'VOWEL', 'VULGAR', 'WAFER', 'WAGER',
  'WAGON', 'WAIST', 'WALTZ', 'WATCH', 'WATER', 'WAVER', 'WAXEN', 'WEARY',
  'WEAVE', 'WEDGE', 'WEEDY', 'WEIGH', 'WEIRD', 'WENCH', 'WHACK', 'WHARF',
  'WHEAT', 'WHEEL', 'WHERE', 'WHICH', 'WHIFF', 'WHILE', 'WHINE', 'WHINY',
  'WHIRL', 'WHISK', 'WHITE', 'WHOLE', 'WHOSE', 'WIDEN', 'WIDER', 'WIDOW',
  'WIDTH', 'WIELD', 'WIGHT', 'WINDY', 'WIPED', 'WIPER', 'WITCH', 'WOKEN',
  'WOMAN', 'WOODS', 'WOODY', 'WOOLY', 'WOOZY', 'WORDY', 'WORLD', 'WORRY',
  'WORSE', 'WORST', 'WORTH', 'WOULD', 'WOUND', 'WOVEN', 'WRACK', 'WRATH',
  'WREAK', 'WRECK', 'WREST', 'WRING', 'WRIST', 'WRITE', 'WRONG', 'WROTE',
  'WRUNG', 'YACHT', 'YEARN', 'YEAST', 'YIELD', 'YOUNG', 'YOUTH', 'ZEBRA',
  'ZESTY', 'ZIPPY', 'ZONAL',

  // 6-letter words
  'ANCHOR', 'ANIMAL', 'AUTUMN', 'BAKERY', 'BANANA', 'BASKET', 'BEACON',
  'BEAUTY', 'BEETLE', 'BEHIND', 'BLANKET', 'BLOSSOM', 'BOTTLE', 'BOUNCE',
  'BRANCH', 'BREEZE', 'BRIDGE', 'BRIGHT', 'BROKEN', 'BRONZE', 'BUBBLE',
  'BUCKET', 'BUDGET', 'BUNDLE', 'BURGER', 'BUTTER', 'BUTTON', 'CANDLE',
  'CANYON', 'CASTLE', 'CATTLE', 'CELERY', 'CEMENT', 'CHANCE', 'CHANGE',
  'CHEESE', 'CHERRY', 'CHOICE', 'CIRCLE', 'CIRCUS', 'COBWEB', 'COFFEE',
  'COOKIE', 'COPPER', 'CORNER', 'COSMOS', 'COTTON', 'COURSE', 'COUSIN',
  'CRAYON', 'CREDIT', 'CRUISE', 'DANGER', 'DINNER', 'DOCTOR', 'DONKEY',
  'DOUBLE', 'DRAGON', 'DRAWER', 'DUPLEX', 'EAGLE', 'ENERGY', 'ENGINE',
  'ESCAPE', 'EXPERT', 'FABRIC', 'FALCON', 'FAMILY', 'FAMOUS', 'FARMER',
  'FATHER', 'FEATHER', 'FINGER', 'FLAVOR', 'FLIGHT', 'FLOWER', 'FOREST',
  'FREEZE', 'FRIEND', 'FROZEN', 'GARDEN', 'GENTLE', 'GINGER', 'GLOBAL',
  'GOLDEN', 'GRANNY', 'GUITAR', 'HAMMER', 'HAPPEN', 'HARBOR', 'HEALTH',
  'HEAVEN', 'HELMET', 'HOCKEY', 'HOLLOW', 'HONEST', 'HUNGRY', 'HUNTER',
  'IGUANA', 'INSECT', 'ISLAND', 'JACKET', 'JIGSAW', 'JOGGER', 'JUNGLE',
  'KENNEL', 'KETTLE', 'KITTEN', 'LADDER', 'LAPTOP', 'LAUNCH', 'LAVA',
  'LEADER', 'LEGEND', 'LEMON', 'LETTER', 'LISTEN', 'LITTLE', 'LIZARD',
  'LUMBER', 'MAGNET', 'MANGO', 'MANNER', 'MARBLE', 'MARKET', 'MEADOW',
  'MEMORY', 'MIDDLE', 'MINUTE', 'MIRROR', 'MITTEN', 'MONKEY', 'MOTHER',
  'MOTION', 'MUSEUM', 'MUSCLE', 'NATURE', 'NEEDLE', 'NEPHEW', 'NICKEL',
  'NUMBER', 'OBJECT', 'OFFICE', 'ORANGE', 'ORCHID', 'OYSTER', 'PADDLE',
  'PALACE', 'PANDA', 'PARADE', 'PARROT', 'PATENT', 'PEPPER', 'PERSON',
  'PHRASE', 'PICKLE', 'PICNIC', 'PIGEON', 'PILLOW', 'PLANET', 'PLAYER',
  'PLENTY', 'PLIERS', 'POCKET', 'POLICE', 'POLISH', 'PONDER', 'POTATO',
  'POWDER', 'PRAISE', 'PRAYER', 'PRINCE', 'PURPLE', 'PUZZLE', 'RABBIT',
  'RACOON', 'RANDOM', 'REASON', 'RECORD', 'REMOTE', 'REPAIR', 'RESULT',
  'REWARD', 'RIBBON', 'RIDDLE', 'RIPPLE', 'ROCKET', 'RUBBER', 'RUSTIC',
  'SADDLE', 'SAFETY', 'SALMON', 'SAMPLE', 'SANDAL', 'SCARLET', 'SCHOOL',
  'SCREEN', 'SCROLL', 'SEARCH', 'SEASON', 'SECRET', 'SEQUEL', 'SHADOW',
  'SHRIMP', 'SIGNAL', 'SILVER', 'SIMPLE', 'SINGLE', 'SISTER', 'SKETCH',
  'SLEEVE', 'SLIDER', 'SMOOTH', 'SNATCH', 'SOCCER', 'SOCIAL', 'SOCKET',
  'SPIDER', 'SPLASH', 'SPONGE', 'SPOOKY', 'SPRING', 'SQUARE', 'STABLE',
  'STATUE', 'STEADY', 'STEREO', 'STICKY', 'STREET', 'STRIKE', 'STRING',
  'STRIPE', 'STRONG', 'STUDIO', 'STUPID', 'SUBWAY', 'SUFFIX', 'SUMMER',
  'SUMMIT', 'SUNDAY', 'SUNSET', 'SUPPLY', 'SWITCH', 'SYMBOL', 'TABLET',
  'TARGET', 'TEAPOT', 'TEMPLE', 'TENDER', 'TENNIS', 'THANKS', 'THREAD',
  'THROAT', 'THRONE', 'TICKET', 'TIMBER', 'TISSUE', 'TOMATO', 'TONGUE',
  'TRAVEL', 'TREATY', 'TRIPLE', 'TROPHY', 'TUNNEL', 'TURKEY', 'TURTLE',
  'TWELVE', 'UMBRELLA', 'UNIQUE', 'UPDATE', 'VALLEY', 'VELVET', 'VENDOR',
  'VESSEL', 'VIOLET', 'VIOLIN', 'VISION', 'VOYAGE', 'WALLET', 'WALRUS',
  'WARMTH', 'WEALTH', 'WEASEL', 'WIDGET', 'WILLOW', 'WINDOW', 'WINNER',
  'WINTER', 'WISDOM', 'WONDER', 'WORKER', 'YELLOW', 'YOGURT', 'ZENITH',
  'ZIPPER', 'ZOMBIE',

  // 7-letter words
  'AIRPORT', 'ARCHWAY', 'BALLOON', 'BLANKET', 'BLOSSOM', 'CABINET', 'CAPTAIN',
  'CARAMEL', 'CARTOON', 'CATFISH', 'CENTURY', 'CHANNEL', 'CHAPTER', 'CHICKEN',
  'CHIMNEY', 'CLASSIC', 'COCONUT', 'COMPANY', 'COMPASS', 'CONCERT', 'CONTENT',
  'COUNTRY', 'COURAGE', 'CRACKER', 'CRICKET', 'CRYSTAL', 'CURTAIN', 'CUSHION',
  'DAYLIGHT', 'DIAMOND', 'DOLPHIN', 'DOORWAY', 'ELEMENT', 'EMPEROR', 'EVENING',
  'FACTORY', 'FASHION', 'FEATHER', 'FICTION', 'FIREFLY', 'FOOTSTEP', 'FREEDOM',
  'FROSTING', 'GIRAFFE', 'GLACIER', 'GRAPHIC', 'GRAVITY', 'GROCERY', 'HABITAT',
  'HAMSTER', 'HARMONY', 'HARVEST', 'HEALTHY', 'HIGHWAY', 'HISTORY', 'HOLIDAY',
  'HORIZON', 'HUNDRED', 'ICEBERG', 'IMAGINE', 'INSECTS', 'JANUARY', 'JOURNEY',
  'JUSTICE', 'KITCHEN', 'LANTERN', 'LAUNDRY', 'LEOPARD', 'LIBRARY', 'LOBSTER',
  'MACHINE', 'MAILBOX', 'MAMMOTH', 'MANSION', 'MERMAID', 'MESSAGE', 'MINERAL',
  'MISSION', 'MONSTER', 'MORNING', 'MYSTERY', 'NATURAL', 'NETWORK', 'NOWHERE',
  'OCTOPUS', 'OFFICER', 'OPINION', 'OUTDOOR', 'PACKAGE', 'PANCAKE', 'PANTHER',
  'PARSLEY', 'PARTNER', 'PASSAGE', 'PATTERN', 'PEACOCK', 'PENGUIN', 'PERFECT',
  'PICTURE', 'PIONEER', 'PLASTIC', 'PLUMBER', 'POPULAR', 'POPCORN', 'PORTION',
  'POTTERY', 'PRAIRIE', 'PRESENT', 'PRETZEL', 'PRIMARY', 'PRIVATE', 'PROBLEM',
  'PROCESS', 'PRODUCT', 'PROJECT', 'PROMISE', 'PROTEIN', 'PUMPKIN', 'QUALITY',
  'QUARTER', 'RAINBOW', 'REALITY', 'REPTILE', 'REQUEST', 'RESPECT', 'RHUBARB',
  'ROOFTOP', 'SALTINE', 'SANDBOX', 'SEAFOOD', 'SERPENT', 'SESSION', 'SHELTER',
  'SHERIFF', 'SILENCE', 'SIRLOIN', 'SIXTEEN', 'SKIPPER', 'SKYLINE', 'SOCIETY',
  'SOLDIER', 'SPARKLE', 'SPECIES', 'SPINACH', 'STADIUM', 'STAIRWAY', 'STATION',
  'STORAGE', 'STRANGE', 'STUDENT', 'SUBJECT', 'SUCCESS', 'SUMMONS', 'SUNFLOWER',
  'SUNRISE', 'SUPPORT', 'SURFACE', 'SWEATER', 'TEACHER', 'TEXTURE', 'THEATER',
  'THOUGHT', 'THUNDER', 'TRAFFIC', 'TRAILER', 'TRAMPOLINE', 'TREASURE', 'TRICYCLE',
  'TROUBLE', 'TRUMPET', 'TUESDAY', 'TWINKLE', 'UNIFORM', 'UNKNOWN', 'UPGRADE',
  'UTILITY', 'VANILLA', 'VARIETY', 'VEHICLE', 'VERSION', 'VICTORY', 'VILLAGE',
  'VINEGAR', 'VOLCANO', 'VULTURE', 'WARNING', 'WEEKEND', 'WELCOME', 'WESTERN',
  'WHISKER', 'WHISTLE', 'WILDEBEEST', 'WILDFIRE', 'WINDING', 'WORKOUT', 'WORSHIP',
  'WRAPPER', 'WRINKLE', 'WRITING', 'YOGHURT', 'YOUNGER', 'ZEPHYR', 'ZUCCHINI'
];

/**
 * Get a random selection of words from the word bank
 * @param count Number of words to select
 * @param minLength Minimum word length (default 4)
 * @param maxLength Maximum word length (default 7, to fit in 10x10 grid with room for zig-zag)
 * @returns Array of randomly selected words
 */
export function getRandomWords(
  count: number,
  minLength: number = 4,
  maxLength: number = 7
): string[] {
  // Filter words by length
  const validWords = WORD_BANK.filter(
    word => word.length >= minLength && word.length <= maxLength
  );

  // Shuffle and select
  const shuffled = [...validWords].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}
